<template>
    <div class="flex gap-4 px-2 py-4 border-t">
          <div class="flex flex-1 items-center level-heading gap-4">
              <div class="flex-1 mr-auto">
                <div class="text-xl truncate">{{sponsor.sponsor_name}}</div>
                <div class="text-xs font-semibold text-gray-600">{{sponsor.level}} {{sponsor.modifier || ''}}</div>
              </div>
              <div v-if="!isEventArchived" class="flex gap-2 mr-px flex-shrink-0 items-center">
                  <svg v-if="sponsor.hidden" v-tooltip="'Hidden'"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-700 w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                  </svg>
                  <button @click="$emit('set-edit-sponsor', sponsor)" class="btn-blue-outline btn-xs">Edit</button>
                  <button @click="$emit('remove-sponsor', sponsor)" class="btn-red-outline btn-xs">&#x2715;</button>
              </div>
          </div>
    </div>
  </template>

<script>
export default {
  props: {
    isEventArchived: {
      type: Boolean,
      default: false
    },
    sponsor: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

  <style>
  .level-heading {
    padding-top: 3px;
  }
  </style>
